import { SCENE_AUDIO } from "./audio/scenes";
import { SCENE_INTERACTIVES as INTERACTIVES } from "./interactive/scenes";
import BACKGROUND from "./background/scenes";
import { SceneDataConfig, Scenes } from "./types";
import { SCENE_STATES } from "./states";

export const ALL_SCENES = [
	"SPLASH_SCREEN",
	"CABIN_HUB",
	"CABIN_CAT",
	"CABIN_COUCH",
	"CABIN_RADIO",
	"CABIN_GAME_TABLE",
	"CABIN_FIREPLACE",
	"CABIN_WINDOW",
	"CABIN_LIBRARY",
	"CABIN_DESK",
	"CABIN_DESK_DRAWER",
	"CABIN_EXIT",
	"CABIN_KITCHEN",
	"PLANE",
	"CABANA",
	"CABANA_BEACH",
	"PLANE_RETURN",
	"INTERACTIVE_CAT",
] as const;

export const SCENES: Record<Scenes, SceneDataConfig> = {
	SPLASH_SCREEN: {
		path: "/",
		state: SCENE_STATES.SPLASH_SCREEN,
		background: BACKGROUND.SPLASH_SCREEN,
		audio: SCENE_AUDIO.SPLASH_SCREEN,
		interactiveComponents: INTERACTIVES.SPLASH_SCREEN,
	},
	CABIN_HUB: {
		path: "/cabin-hub",
		state: SCENE_STATES.CABIN_HUB,
		background: BACKGROUND.CABIN_HUB,
		audio: SCENE_AUDIO.CABIN_HUB,
		interactiveComponents: INTERACTIVES.CABIN_HUB,
	},
	CABIN_CAT: {
		path: "/cabin-hub/cat",
		state: SCENE_STATES.CABIN_CAT,
		background: BACKGROUND.CABIN_CAT,
		audio: SCENE_AUDIO.CAT,
		interactiveComponents: INTERACTIVES.CABIN_CAT,
	},
	CABIN_COUCH: {
		path: "/cabin-hub/couch",
		state: SCENE_STATES.CABIN_COUCH,
		background: BACKGROUND.CABIN_COUCH,
		audio: SCENE_AUDIO.COUCH,
		interactiveComponents: INTERACTIVES.CABIN_COUCH,
	},
	CABIN_RADIO: {
		path: "/cabin-hub/radio",
		state: SCENE_STATES.CABIN_RADIO,
		background: BACKGROUND.CABIN_RADIO,
		audio: SCENE_AUDIO.RADIO,
		interactiveComponents: INTERACTIVES.CABIN_RADIO,
	},
	CABIN_GAME_TABLE: {
		path: "/cabin-hub/game-table",
		state: SCENE_STATES.CABIN_GAME_TABLE,
		background: BACKGROUND.CABIN_GAME_TABLE,
		audio: SCENE_AUDIO.GAME_TABLE,
		interactiveComponents: INTERACTIVES.CABIN_GAME_TABLE,
	},
	CABIN_FIREPLACE: {
		path: "/cabin-hub/fireplace",
		state: SCENE_STATES.CABIN_FIREPLACE,
		background: BACKGROUND.CABIN_FIREPLACE,
		audio: SCENE_AUDIO.FIREPLACE,
		interactiveComponents: INTERACTIVES.CABIN_FIREPLACE,
	},
	CABIN_WINDOW: {
		path: "/cabin-hub/window",
		state: SCENE_STATES.CABIN_WINDOW,
		background: BACKGROUND.CABIN_WINDOW,
		audio: SCENE_AUDIO.WINDOW,
		interactiveComponents: INTERACTIVES.CABIN_WINDOW,
	},
	CABIN_LIBRARY: {
		path: "/cabin-hub/library",
		state: SCENE_STATES.CABIN_LIBRARY,
		background: BACKGROUND.CABIN_LIBRARY,
		audio: SCENE_AUDIO.LIBRARY,
		interactiveComponents: INTERACTIVES.CABIN_LIBRARY,
		disabled: true,
	},
	CABIN_DESK: {
		path: "/cabin-hub/desk",
		state: SCENE_STATES.CABIN_DESK,
		background: BACKGROUND.CABIN_DESK,
		audio: SCENE_AUDIO.DESK,
		interactiveComponents: INTERACTIVES.CABIN_DESK,
	},
	CABIN_DESK_DRAWER: {
		path: "/cabin-hub/desk/drawer",
		state: SCENE_STATES.CABIN_DESK_DRAWER,
		background: BACKGROUND.CABIN_DESK_DRAWER,
		audio: SCENE_AUDIO.DESK_DRAWER,
		interactiveComponents: INTERACTIVES.CABIN_DESK_DRAWER,
	},
	CABIN_EXIT: {
		path: "/cabin-exit",
		state: SCENE_STATES.CABIN_EXIT,
		background: BACKGROUND.CABIN_EXIT,
		audio: SCENE_AUDIO.CABIN_EXIT,
		interactiveComponents: INTERACTIVES.CABIN_EXIT,
	},
	CABIN_KITCHEN: {
		path: "/cabin-kitchen",
		state: SCENE_STATES.CABIN_KITCHEN,
		background: BACKGROUND.CABIN_KITCHEN,
		audio: SCENE_AUDIO.CABIN_KITCHEN,
		interactiveComponents: INTERACTIVES.CABIN_KITCHEN,
		disabled: true,
	},
	PLANE: {
		path: "/plane",
		state: SCENE_STATES.PLANE,
		navigateAfterVideo: "/cabana",
		background: BACKGROUND.PLANE,
		audio: SCENE_AUDIO.PLANE,
		interactiveComponents: INTERACTIVES.PLANE,
	},
	CABANA: {
		path: "/cabana",
		state: SCENE_STATES.CABANA,
		background: BACKGROUND.CABANA,
		audio: SCENE_AUDIO.CABANA,
		interactiveComponents: INTERACTIVES.CABANA,
	},
	CABANA_BEACH: {
		path: "/cabana/beach",
		state: SCENE_STATES.CABANA_BEACH,
		background: BACKGROUND.CABANA_BEACH,
		audio: SCENE_AUDIO.CABANA_BEACH,
		interactiveComponents: INTERACTIVES.CABANA_BEACH,
	},
	PLANE_RETURN: {
		path: "/plane-return",
		state: SCENE_STATES.PLANE_RETURN,
		navigateAfterVideo: "/cabin-hub",
		background: BACKGROUND.PLANE_RETURN,
		audio: SCENE_AUDIO.PLANE,
		interactiveComponents: INTERACTIVES.PLANE_RETURN,
	},
	INTERACTIVE_CAT: {
		path: "/cabin-hub/cat/interactive",
		state: SCENE_STATES.INTERACTIVE_CAT,
		navigateAfterVideo: "/cabin-hub/cat",
		background: BACKGROUND.CABIN_CAT,
		audio: SCENE_AUDIO.CAT,
		interactiveComponents: INTERACTIVES.INTERACTIVE_CAT,
	},
};
